import { type CSSProperties, type FC } from "react";

import { Box, Text } from "@mantine/core";
import { Spacing } from "@snapchat/snap-design-system";

import { typeIcon, typeLabel } from "./RemoteAssetPreview.module.css";

const TYPE_CONFIG: Record<string, { label: string; color: string }> = {
    MESH: { label: "3D", color: "#6B5CE7" },
    TEXTURE: { label: "TX", color: "#2E8B57" },
    SCENE: { label: "SC", color: "#5B5B8A" },
    SCRIPT: { label: "JS", color: "#4A7FB5" },
    AUDIO: { label: "♪", color: "#8B6914" },
    ML_ASSET: { label: "ML", color: "#7B4FA0" },
};

const DEFAULT_CONFIG = { label: "?", color: "#555" };

interface RemoteAssetTypeIconProps {
    type: string;
    size?: number;
}

export const RemoteAssetTypeIcon: FC<RemoteAssetTypeIconProps> = ({ type, size = Spacing.XL }) => {
    const config = TYPE_CONFIG[type] ?? DEFAULT_CONFIG;

    return (
        <Box
            className={typeIcon}
            style={
                {
                    "--remote-asset-preview-size": `${size}px`,
                    "--remote-asset-type-color": config.color,
                } as CSSProperties
            }
        >
            <Text size="xs" fw={700} className={typeLabel}>
                {config.label}
            </Text>
        </Box>
    );
};
